import CheckOut from './checkout'
import Home from './home'
import Lessons from './lessons'
import Packages from './packages'
import PlayerPage from './player'
import Profile from './profile'

const Private = {
  Home,
  Lessons,
  PlayerPage,
  Profile,
  Packages,
  CheckOut,
}

export { Private }
